import { IonIcon } from '@ionic/react';
import { Tooltip } from 'antd';
import { alertCircleOutline } from 'ionicons/icons';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isProviderEnabledForDoc } from '../../../config/utils/providerUtils';
import { selectCompanyProviderSettings } from '../../../store/companies/companiesSlice';
import { useAppSelector } from '../../../store/hooks';

interface Props {
  field: any;
  formik: any;
}

export const ProviderToggle = ({ field, formik }: Props) => {
  const { t } = useTranslation();
  const providerSettings = useAppSelector(selectCompanyProviderSettings);
  const documentType = useMemo(() => formik?.values?.documentTypeId?.object?.aadeCode, [formik]);
  const isEnabled = useMemo(
    () => isProviderEnabledForDoc(providerSettings, documentType),
    [documentType, providerSettings],
  );

  useEffect(() => {
    formik?.setFieldValue?.(field?.name, !!isEnabled);
  }, [field?.name, isEnabled]);

  const getSection = useCallback(() => {
    if (isEnabled) {
      return (
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', top: 4, right: 4 }}>
            <Tooltip title={t('FORMS.PROVIDER_POST')}>
              <IonIcon icon={alertCircleOutline} style={{ fontSize: 18 }} color="primary"></IonIcon>
            </Tooltip>
          </div>
        </div>
      );
    }
  }, [isEnabled, t]);

  return getSection();
};
